import { categoryIconsMap } from "../../../config/categoryIcons";
import { FaUtensils } from "react-icons/fa";
import { getCategoryKey } from "../../../services/customerMenuModel";

const CategoryChips = ({ categories, activeKey, onChange }) => (
  <div className="overflow-x-auto px-4 pb-3 pt-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" aria-label="دسته‌بندی‌های منو">
    <div className="mx-auto flex w-max min-w-full max-w-5xl gap-2">
      <button type="button" aria-pressed={activeKey === "all"} onClick={() => onChange("all")} className={`min-h-10 shrink-0 rounded-full border px-4 text-sm font-bold transition-colors ${activeKey === "all" ? "border-primary bg-primary text-white" : "border-gray-200 bg-white text-gray-700 hover:border-primary/50"}`}>همه</button>
      {categories.map((category) => {
        const key = getCategoryKey(category);
        const Icon = categoryIconsMap[category.icon] || FaUtensils;
        const active = activeKey === key;
        return (
          <button key={key} type="button" aria-pressed={active} onClick={() => onChange(key)} className={`inline-flex min-h-10 shrink-0 items-center gap-2 rounded-full border px-4 text-sm font-bold transition-colors ${active ? "border-primary bg-primary text-white" : "border-gray-200 bg-white text-gray-700 hover:border-primary/50"}`}>
            <Icon aria-hidden="true" style={active ? undefined : { color: category.iconColor || "#F88225" }} />
            {category.name}
          </button>
        );
      })}
    </div>
  </div>
);

export default CategoryChips;
